import { useState } from "react";
import { PanelMenu } from "primereact/panelmenu";
import Packages from "./packages";
import Investors from "./investors";

export default function InviestorAdmin() {
  const [activePage, setActivePage] = useState("Packages");

  const items = [
    {
      label: "Packages",
      icon: "pi pi-box",
      command: () => setActivePage("Packages"),
    },
    {
      label: "Investors",
      icon: "pi pi-cog",
      command: () => setActivePage("Investors"),
    },
  ];

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-100 border-r p-3">
        <h2 className="text-lg font-bold mb-4">Admin Panel</h2>
        <PanelMenu model={items} className="w-full" />
      </aside>

      {/* Right Content */}
      <main className="flex-1 px-6 overflow-auto">
        <div className="bg-white p-0">
          {activePage === "Packages" && <Packages />}
          {activePage === "Investors" && <Investors />}
        </div>
      </main>
    </div>
  );
}
